import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../reducers';
import { EventType, EventService } from '../services/events/events';
import ErrorIcon from '@material-ui/icons/Error';
import ChatIcon from 'material-ui/svg-icons/communication/chat';
import { Error } from '../types/Errors/Error';
import { isNullOrUndefined } from 'util';
import {
    ActionType as ErrorInfoActionType,
    Actions as ErrorActions
} from '../actions/errorInfo';
import { TwilioChatService } from '../services/twilio/chat';
import { JobStatus } from '../types/enums/JobStatus';
import {
    Actions as ChatActions,
    ActionType as ChatActionType
} from '../actions/chat';
import { StringResources } from '../localization/StringResources';
import { Strings } from '../localization';
import { ChatMessage } from '../types/ChatMessage';
import { Api } from '../services/api/api';
import CustomSnackBar from '../components/CustomSnackBar';
import { RouterState, RouterAction, routerActions } from 'react-router-redux';
import { ROUTES } from '../constants/routes';

interface BaseProps {
    isDrawerOpen: boolean;
    error?: Error;
    clearErrorStack: () => ErrorInfoActionType;
}

interface PassedProps {
    classname?: string;
    pageName: EventType;
}

interface ChatProps {
    jobId: string;
    originatedFrom: string;
    isBiddingInProgress: boolean;
    isJobInProgress: boolean;
    clientId: string;
    providerId: string;
    unreadedMessagesCount: number;
    isTwilioClientInitialized: boolean;

    updateMessages: (messages: ChatMessage[]) => ChatActionType;
    SetTwilioClientInitializedStatus: (
        isClientInitialized: boolean
    ) => ChatActionType;
    SetMessagesReceived: (status: boolean) => ChatActionType;
    updateNewMessagesCounter: (count: number) => ChatActionType;
    routePush: (location: string) => RouterAction;
}

interface BaseState {
    errorBarOpened: boolean;
    newMessagesBarIsOpened: boolean;
}

interface ChatState {
    twilioToken: string;
    unreadedMessagesCount: number;
}

class Base extends React.Component<
    BaseProps & PassedProps & ChatProps,
    BaseState & ChatState
> {
    private divElement: any;
    constructor(props: any) {
        super(props);
        this.divElement = null;
        this.state = {
            errorBarOpened: !isNullOrUndefined(this.props.error),
            newMessagesBarIsOpened: false,
            twilioToken: '',
            unreadedMessagesCount: 0
        };
        this.props.SetTwilioClientInitializedStatus(false);
    }

    async componentWillReceiveProps(
        nextProps: BaseProps & PassedProps & ChatProps
    ) {
        nextProps.error
            ? this.setState({ errorBarOpened: true })
            : this.setState({ errorBarOpened: false });

        if (
            this.props.jobId &&
            !this.props.isTwilioClientInitialized &&
            this.props.pageName != EventType.CHAT &&
            this.state.twilioToken &&
            (this.props.isBiddingInProgress || this.props.isJobInProgress)
        ) {
            await this.initTwilioChat(this.state.twilioToken);
        }
        if (
            nextProps.unreadedMessagesCount &&
            nextProps.unreadedMessagesCount > 0 &&
            nextProps.unreadedMessagesCount !=
                this.state.unreadedMessagesCount &&
            this.props.pageName != EventType.CHAT
        ) {
            this.setState({
                newMessagesBarIsOpened: true,
                unreadedMessagesCount: nextProps.unreadedMessagesCount
            });
        }
    }

    componentDidMount() {
        let domRect = this.divElement.getBoundingClientRect();
        let event = {
            eventType: this.props.pageName,
            width: domRect.width,
            height: domRect.height
        };
        console.log(event);
        EventService.pushEvent(event);
        this.props.SetMessagesReceived(false);
        if (this.props.jobId) {
            Api.getTwilioToken()
                .then(token => {
                    let twilioToken = JSON.parse(token);
                    this.setState({ twilioToken: twilioToken });

                    if (EventType.CHAT == this.props.pageName) {
                        this.initTwilioChat(this.state.twilioToken);
                    }
                })
                .catch(error => {
                    console.log('get twilio token error', error);
                });
        }
    }

    componentWillUnmount() {
        this.props.clearErrorStack();
        this.props.SetTwilioClientInitializedStatus(false);
        this.props.SetMessagesReceived(false);
        this.props.updateNewMessagesCounter(0);

        TwilioChatService.getInstance().removeMessageAddedListener();
    }

    onErrorSnackBarClose = () => {
        this.setState({ errorBarOpened: false });
        this.props.clearErrorStack();
    };

    onNewMessagesSnackBarClose = event => {
        this.setState({ newMessagesBarIsOpened: false });
        event.stopPropagation();
    };

    onNewMessagesSnackBarClick = () => {
        this.setState({ newMessagesBarIsOpened: false });
        this.props.routePush(ROUTES.CHAT);
    };
    async initTwilioChat(twilioToken: string) {
        this.props.updateMessages([]);
        const twilio = TwilioChatService.getInstance();
        if(twilio.initializing)
            return;

        console.log(this.props);
        console.log('validate job');
        const { isBiddingInProgress, isJobInProgress } = this.props;
        if (!isBiddingInProgress && !isJobInProgress) return;

        twilio.initializing = true;
        console.log('init access manager');
        if (!twilio.initializeAccessManager(twilioToken))
        {
            twilio.initializing = false;
            return;
        }

        try {
            console.log('init client');
            await twilio.initializeClient(twilioToken);
            console.log('get channels')
            let channels = await twilio.getAllChannels();
            console.log(channels.map(ch => ch.uniqueName));

            const { clientId, providerId, jobId } = this.props;
            const channelCode = isBiddingInProgress
                ? jobId
                : `${clientId}_${jobId}_${providerId}`;
            let channel = channels.find(ch => ch.uniqueName === channelCode);
            console.log(`get channel by ${channelCode}: ${channel}`);

            const { originatedFrom } = this.props;
            if (!channel) {
                console.log('move original channels');
                const originalChannels = channels.filter(ch => ch.uniqueName.indexOf(originatedFrom) >= 0);
                for(const originatedChannel of originalChannels){
                    await twilio.moveChannel(originatedChannel, originatedChannel.uniqueName.replace(originatedFrom, jobId));
                }

                console.log('get channels')
                channels = await twilio.getAllChannels();
                console.log(channels.map(ch => ch.uniqueName));

                channel = channels.find(ch => ch.uniqueName === channelCode);
                console.log(`get channel by ${channelCode}: ${channel}`);

                if(!channel)
                    channel = await twilio.createChannel(channelCode)
            }

            if (!channel)
            {
                twilio.initializing = false;
                return;
            }

            try {
                console.log(`join channel`);
                await twilio.joinChannel(channel);
            }catch(e){
                console.error(e);
            } finally {
                const messages = await twilio.getMessages();
                console.log(`get messages: ${messages.length}`);

                if (this.props.pageName === EventType.CHAT) {
                    console.log('set all messages consumed');
                    await channel.setAllMessagesConsumed();
                } else {
                    const unconsumedMessagesCount = await channel.getUnconsumedMessagesCount();
                    const messagesCount = await channel.getMessagesCount();

                    console.log(`update messages counter: ${unconsumedMessagesCount}/${messagesCount}`);
                    this.props.updateNewMessagesCounter(
                        isNullOrUndefined(unconsumedMessagesCount) ? messagesCount : unconsumedMessagesCount
                    );
                }

                console.log(`update messages`);
                this.props.updateMessages(messages);
                this.props.SetMessagesReceived(true);
                this.props.SetTwilioClientInitializedStatus(true);
                twilio.initializing = false;
            }
        } catch (e) {
            twilio.initializing = false;
            console.error(e);
        }
    }

    render() {
        let classname = this.props.classname
            ? `App ${this.props.classname}`
            : 'App';
        return (
            <div
                className={classname}
                ref={divElement => {
                    this.divElement = divElement;
                }}
            >
                <CustomSnackBar
                    isOpened={this.state.errorBarOpened}
                    className="error-snackbar"
                    contentClassName="error-snackbar-content"
                    message={
                        <span
                            id="client-snackbar"
                            style={{ display: 'flex', alignItems: 'center' }}
                        >
                            <ErrorIcon
                                style={{
                                    paddingLeft: '5px',
                                    paddingRight: '5px'
                                }}
                            />
                            {this.props.error ? this.props.error.message : ''}
                        </span>
                    }
                    onClose={this.onErrorSnackBarClose}
                />

                <CustomSnackBar
                    isOpened={this.state.newMessagesBarIsOpened}
                    className="new-messages-snackbar"
                    contentClassName="error-snackbar-content"
                    message={
                        <span
                            id="client-snackbar"
                            style={{ display: 'flex', alignItems: 'center' }}
                        >
                            <ChatIcon
                                style={{
                                    paddingLeft: '5px',
                                    paddingRight: '5px',
                                    height: '40px',
                                    width: '40px'
                                }}
                            />
                            {this.props.unreadedMessagesCount
                                ? StringResources.getString(
                                      Strings.Chat.SnackBarNewMessages.message,
                                      this.props.unreadedMessagesCount
                                  )
                                : ''}
                        </span>
                    }
                    onClose={this.onNewMessagesSnackBarClose}
                    onSnackBarClick={this.onNewMessagesSnackBarClick}
                />

                {this.props.children}
            </div>
        );
    }
}

function mapStateToProps(state: StoreState) {
    return {
        isDrawerOpen: state.drawer.isOpen,
        error: state.errorInfo.lastError,
        jobId: state.jobDetails.jobId,
        originatedFrom: state.jobDetails.originatedFrom,
        jobStatus: state.jobDetails.status,
        clientId: state.auth.user && state.auth.user.email,
        providerId: state.jobDetails.providerId,
        isTwilioClientInitialized: state.chat.isTwilioClientInitialized,
        unreadedMessagesCount: state.chat.newMessagesCounter,
        isBiddingInProgress:
            state.jobDetails.status == JobStatus.BIDDING_ACTIVE ||
            state.jobDetails.status == JobStatus.CREATED ||
            state.jobDetails.status == JobStatus.UNDER_REVIEW,
        isJobInProgress:
            state.jobDetails.status == JobStatus.ACCEPTED ||
            state.jobDetails.status == JobStatus.HAULER_ARRIVING ||
            state.jobDetails.status == JobStatus.CONFIRM_ARRIVAL
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return {
        routePush: (location: string) => dispatch(routerActions.push(location)),
        clearErrorStack: () => dispatch(ErrorActions.clearAll()),
        updateMessages: (messages: ChatMessage[]) =>
            dispatch(ChatActions.updateMessages(messages)),
        SetTwilioClientInitializedStatus: (isClientInitialized: boolean) =>
            dispatch(
                ChatActions.SetTwilioClientInitializedStatus(
                    isClientInitialized
                )
            ),
        SetMessagesReceived: (status: boolean) =>
            dispatch(ChatActions.MessagesReceived(status)),
        updateNewMessagesCounter: (count: number) =>
            dispatch(ChatActions.updateNewMessagesCounter(count))
    };
}

export const BaseContainer = connect<{}, {}, PassedProps>(
    mapStateToProps,
    mapDispatchToProps
)(Base);



// WEBPACK FOOTER //
// ./src/containers/BaseContainer.tsx